import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { sanitizeHtml } from "../../../../shared/sanitize";
import CloseIcon from "../../../../assets/icons/close.svg";
import { ReactComponent as Warning } from "../../../../assets/icons/warning-red.svg";
import StyledModal from "../../../common/Modal/StyledModal";

const ChangeValuesModal = ({
  changeValuesModalIsOpen,
  closeModalChangeValues,
  changeValuesModal,
  continueButton,
}) => {
  let customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "37%",
      borderRadius: "30px",
    },
  };

  const mediaMatch = window.matchMedia("(max-width: 850px)");
  mediaMatch.matches === true
    ? (customStyles.content = {
        ...customStyles.content,
        width: "70%",
      })
    : (customStyles.content = {
        ...customStyles.content,
        width: "37%",
      });

  return (
    <StyledModal>
      <Modal
        isOpen={changeValuesModalIsOpen}
        onRequestClose={closeModalChangeValues}
        style={customStyles}
        contentLabel="Quit Modal"
        overlayClassName="overlay-modal"
        shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
      >
        <button
          onClick={closeModalChangeValues}
          className="close-icon-button "
          data-testid="paf-confirm-change-values-close-button"
        >
          <img src={CloseIcon} alt="Close Icon" />
        </button>
        <div className="wrapper-modal" data-testid="paf-confirm-change-values-modal">
          <div className="image">
            <Warning />
          </div>
          <div
            className="main-text-error"
            data-testid="paf-confirm-change-values-title"
          >
            {changeValuesModal?.title}
          </div>
          {typeof changeValuesModal.description === "object" ? (
            <div
              className="second-text"
              data-testid="paf-confirm-change-values-description"
            >
              {changeValuesModal.description}
            </div>
          ) : (
            <div
              className="second-text"
              data-testid="paf-confirm-change-values-description"
              dangerouslySetInnerHTML={sanitizeHtml(changeValuesModal.description)}
            />
          )}
        </div>
        <div
          className="wrapper-buttons"
          data-testid="paf-confirm-change-values-actions"
        >
          <button
            className="cancel mr-6"
            onClick={closeModalChangeValues}
            data-testid="paf-confirm-change-values-cancel-button"
          >
            Cancel
          </button>
          <button
            className="red-button"
            data-testid="paf-confirm-change-values-continue-button"
            onClick={() => continueButton(changeValuesModal.typeOfError)}
          >
            Continue
          </button>
        </div>
      </Modal>
    </StyledModal>
  );
};

ChangeValuesModal.propTypes = {
  changeValuesModalIsOpen: PropTypes.bool,
  closeModalChangeValues: PropTypes.func,
  changeValuesModal: PropTypes.object,
  continueButton: PropTypes.func,
};

export default ChangeValuesModal;
